import { Filter as FilterIcon, BarChart3, DollarSign, Users, MousePointerClick, TrendingUp, Zap, RefreshCw, Star, type LucideIcon } from "lucide-react";

export { trustAvatars } from "./trust-avatars";

export type ConversionItem = { label: string; description: string; Icon: LucideIcon; bgClass: string; textClass: string };

export const conversionItems: ConversionItem[] = [
  { label: "Leads", description: "Attract the right visitors.", Icon: FilterIcon, bgClass: "bg-[#3b82f6]/10", textClass: "text-[#3b82f6]" },
  { label: "Sales", description: "Guide people to take action.", Icon: DollarSign, bgClass: "bg-[#ec4899]/10", textClass: "text-[#ec4899]" },
  { label: "Bookings", description: "Turn interest into confirmed bookings.", Icon: BarChart3, bgClass: "bg-[#a855f7]/10", textClass: "text-[#a855f7]" },
  { label: "Growth", description: "Turn customers into long-term growth.", Icon: TrendingUp, bgClass: "bg-[#22c55e]/10", textClass: "text-[#22c55e]" },
];

export type GrowthItem = { title: string; description: string; Icon: LucideIcon; bgClass: string; textClass: string };

export const growthItems: GrowthItem[] = [
  {
    title: "Attract the right visitors",
    description: "Make your offer clear so the right people stay.",
    Icon: Users,
    bgClass: "bg-[#3b82f6]/10",
    textClass: "text-[#3b82f6]",
  },
  {
    title: "Guide people to act",
    description: "Point them to the next step: a call, a quote, or a booking.",
    Icon: MousePointerClick,
    bgClass: "bg-[#a855f7]/10",
    textClass: "text-[#a855f7]",
  },
  {
    title: "Drive real growth",
    description: "A site that works harder than a digital brochure.",
    Icon: TrendingUp,
    bgClass: "bg-[#ec4899]/10",
    textClass: "text-[#ec4899]",
  },
];

export const designSubscriptionGrowthItems: GrowthItem[] = [
  {
    title: "Fast turnarounds",
    description: "Most requests come back in about two business days.",
    Icon: Zap,
    bgClass: "bg-[#3b82f6]/10",
    textClass: "text-[#3b82f6]",
  },
  {
    title: "Unlimited requests",
    description: "One flat monthly rate. Add as many requests as you want.",
    Icon: RefreshCw,
    bgClass: "bg-[#a855f7]/10",
    textClass: "text-[#a855f7]",
  },
  {
    title: "Senior-level quality",
    description: "Creative director with 20+ years of brand & web experience.",
    Icon: Star,
    bgClass: "bg-[#ec4899]/10",
    textClass: "text-[#ec4899]",
  },
];
